import { render, staticRenderFns } from "./pluginPage.vue?vue&type=template&id=5695f0be&"
import script from "./pluginPage.vue?vue&type=script&lang=js&"
export * from "./pluginPage.vue?vue&type=script&lang=js&"
import style0 from "./pluginPage.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports